import icons from '@web-packages/icons';
import { ButtonProps as MuiButtonProps } from '@mui/material/Button';

export const types = {
  button: 'button',
  submit: 'submit',
};

type BaseProps = {
  id?: string;
  color?: MuiButtonProps['color'];
  variant?: MuiButtonProps['variant'];
  type?: keyof typeof types;
  onClick?: () => void;
  disabled?: boolean;
  isLoadingScene?: boolean;
  showSkeleton?: boolean;
  startIconName?: keyof typeof icons;
  endIconName?: keyof typeof icons;
  badgeNumber?: number;
  shape?: 'round' | 'square';
  isSmall?: boolean;
  ignoreDisabledColor?: boolean;
  preventPadding?: boolean;
};

export type ButtonProps = BaseProps & (
  | { label: string; children?: never }
  | { label?: never; children: React.ReactNode }
);
